import { DocumentNode, FieldNode, OperationDefinitionNode } from 'graphql';

export const findRootNameInQuery = <Q extends DocumentNode>(query: Q) => {
  const operation = query.definitions.find((d): d is OperationDefinitionNode => d.kind === 'OperationDefinition');
  if (!operation) {
    console.error(query);
    throw new Error('OperationDefinition not found in query');
  }

  const queryField = operation.selectionSet.selections.find((value): value is FieldNode => value.kind === 'Field');
  if (!queryField) {
    console.error(query, operation);
    throw new Error('Unable to find root selection field');
  }

  return queryField.name.value;
}